import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [email, setEmail] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Email submitted:', email);
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="relative min-h-screen" id="hero">
      {/* Background split design */}
      <div className="sticky top-0">
        <div className="grid grid-cols-2 h-full">
          <div className="bg-black"></div>
          <div className="bg-gray-100"></div>
        </div>
      </div>

      <div className="relative min-h-screen grid grid-cols-1 md:grid-cols-2">
        {/* Left Column - Text Content */}
        <div className="bg-black min-h-screen flex items-center justify-center">
          <div className={`pt-[2rem] md:pt-[4rem] mt-[5rem]  pb-6 md:pb-12  pl-[3rem] md:pl-[6rem]  pr-[4rem] md:pr-[4rem] max-w-6xl transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-4xl md:text-5xl text-white mb-6 font-[Montserrat] font-semibold">
              Empowering Your Cloud Journey - Across AWS, GCP & Azure
            </h1>

            <p className="text-lg md:text-xl text-white mb-8 max-w-4xl">
              <span className="font-medium">
                Transform, Optimize & Secure Your Cloud Infrastructure with
                Confidence.
              </span>
              <br />
              <span className="font-light">
                RogerOps specialize in Seamless Migrations, FinOps, DevOps,
                Security & 24/7 Support – tailored for AWS, GCP & Azure. From
                architecting scalable solutions to optimizing your cloud spend,
                RogerOps ensure your business runs smarter, faster and safer in
                the cloud.
              </span>
            </p>

            {/* <p className="text-lg md:text-xl text-white mb-8 max-w-4xl">
              Transform, Optimize & Secure Your Cloud Infrastructure with Confidence.
              RogerOps specialize in Seamless Migrations, FinOps, DevOps, Security & 24/7 Support - tailored for
              AWS, GCP & Azure. From architecting scalable solutions to optimizing your cloud spend, RogerOps ensure 
              your business runs smarter, faster and safer in the cloud. 
            </p> */}

            {/* <form
              onSubmit={handleSubmit}
              className="flex flex-col md:flex-row gap-4 mb-6"
            >
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                className="px-4 py-3 rounded-md text-gray-700 flex-grow md:max-w-md"
                required
              />
              <button
                type="submit"
                className="bg-[#3498db] hover:bg-[#3498dbcc]  text-white px-8 py-3 rounded-md font-medium text-lg transition-colors"
              >
                Sign up
              </button>
            </form>

            <p className="text-white text-sm">
              By signing up, you agree to our{' '}
              <a href="#" className="text-blue-400 hover:underline">
                Terms and Conditions
              </a>{' '}
              and{' '}
              <a href="#" className="text-blue-400 hover:underline">
                Privacy Policy
              </a>
              . We are committed to protecting your data and providing a secure
              experience. Join our community and stay ahead in the cloud.
            </p> */}
            <div className="flex w-full flex-wrap justify-center pt-12 gap-x-10">
              <img
                className="h-32 -ml-6"
                src="/images/aws-icon.png"
                alt="aws"
              />
              <img className="h-32" src="/images/gcp-icon.png" alt="gcp" />
              <img className="h-32" src="/images/azure-icon.png" alt="azure" />
            </div>
          </div>
        </div>

        {/* Right Column - Image */}
        <div className={`relative min-h-screen transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <img
            src="/images/freepik__candid-photography-with-natural-textures-and-highl__7224.jpeg"
            // src="/images/tenweb_media_r6outgbxj.webp"
            alt="Modern office space"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
